// src/components/SelectPrecedentForm.jsx
import React, { useState, useEffect } from 'react';

const SelectPrecedentForm = ({ quote, onSubmit, onCancel }) => {
  const [precedents, setPrecedents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [selectedPrecedent, setSelectedPrecedent] = useState('');
  const [relevanceNote, setRelevanceNote] = useState('');
  
  // Load precedents when component mounts
  useEffect(() => {
    const fetchPrecedents = async () => {
      try {
        setLoading(true);
        const response = await fetch('/api/admin/precedents');
        if (!response.ok) {
          throw new Error('Failed to fetch precedents');
        }
        const data = await response.json();
        setPrecedents(data);
      } catch (error) {
        console.error('Error fetching precedents:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchPrecedents();
  }, []);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedPrecedent || !relevanceNote) {
      alert('All fields are required');
      return;
    }
    
    onSubmit({
      precedent_id: selectedPrecedent,
      relevance_note: relevanceNote
    });
  };
  
  if (loading) {
    return <div className="text-center py-4">Loading historical precedents...</div>;
  }
  
  if (error) {
    return (
      <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4">
        <p className="font-bold">Error</p>
        <p>{error}</p>
      </div>
    );
  }
  
  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <h4 className="font-medium text-lg mb-2">Connect Quote to Historical Precedent</h4>
        <p className="text-sm text-gray-500 mb-4">
          Select a historical precedent that this claim resembles or connects to.
        </p>
      </div>
      
      <div className="space-y-4">
        <div>
          <label htmlFor="precedent" className="block text-sm font-medium text-gray-700 mb-1">
            Historical Precedent
          </label>
          <select
            id="precedent"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            value={selectedPrecedent}
            onChange={(e) => setSelectedPrecedent(e.target.value)}
            required
          >
            <option value="">Select a precedent</option>
            {precedents.map((precedent) => (
              <option key={precedent.id} value={precedent.id}>
                {precedent.country} ({precedent.time_period})
              </option>
            ))}
          </select>
        </div>
        
        <div>
          <label htmlFor="relevanceNote" className="block text-sm font-medium text-gray-700 mb-1">
            Relevance Note
          </label>
          <textarea
            id="relevanceNote"
            rows="4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            value={relevanceNote}
            onChange={(e) => setRelevanceNote(e.target.value)}
            placeholder="Explain how this claim connects to this historical precedent..."
            required
          ></textarea>
        </div>
      </div>
      
      <div className="flex justify-end pt-4 space-x-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-amber-600 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-amber-700"
        >
          Connect
        </button>
      </div>
    </form>
  );
};

export default SelectPrecedentForm;